<template>
  <MsgblContent :type="direction">
      <div class="no-permission">
          <VSvgIcon tag="24" size="24" :icon="icon" class="bubble-icon"/>
          <MsgblTextValue>{{$t('payment.no_permission_to_view')}}</MsgblTextValue>
      </div>
  </MsgblContent>
</template>

<script>
import { VSvgIcon } from '@/modules/common/components'

import {
  MsgblContent,
  MsgblTextValue,
} from './'

export default {
  name: 'MsgblNoAccess',
  components: {
    VSvgIcon,
    MsgblContent,
    MsgblTextValue,
  },
  props: {
    icon: {
      type: String,
      required: true,
    },
    direction: {
      type: String,
      required: true,
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/abstract/_i18n-mixins';
  .bubble-icon {
    @include i-margin-mirror(0, 5px)
  }
  .no-permission {
    display: flex;
    align-items: center;
    padding: 10px;
  }
</style>
